import { FLIGHTS_RESERVE } from '@shared/helpers/routes';
import {
  alternativeFlights,
  validateSelectedSearch,
} from '@shared/services/services';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

const useActionCluster = (setIsScroll, flightsInUSD, infoFlightsSearch) => {
  const history = useHistory();

  const [isBuy, setIsBuy] = useState(false);

  const storageKey = 'fligth_order_time';

  const [differenceBaggage, setDifferenceBaggage] = useState([]);
  const [openModalBaggage, setOpenModalBaggage] = useState(false);
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [difference, setDifference] = useState(null);

  const [notDisponible, setNotDisponible] = useState(false);

  const [body, setBody] = useState(null);
  const [activeRadio, setActiveRadio] = useState(null);

  useEffect(() => {
    if (body) {
      const baggage_hold = activeRadio[0].flight_baggage.baggage_hold;
      const hand_baggage = activeRadio[0].flight_baggage.hand_baggage;
      if (!baggage_hold || !hand_baggage) {
        fetchAlternativeFlights();
      } else {
        fetchValidateSelectedSearch();
      }
    }
  }, [body]);

  const validateBaggage = (is, activeRadio, body) => {
    setIsScroll(true);
    setIsBuy(is);
    setBody(body);
    setActiveRadio(activeRadio);
  };

  const fetchAlternativeFlights = () => {
    alternativeFlights(body)
      .then(res => {
        if (
          res.with_hand_baggage ||
          res.with_hold_baggage ||
          res.with_only_hold_baggage
        ) {
          setIsScroll(false);
          setDifferenceBaggage(res);
          setOpenModalMessage(false);
          setOpenModalBaggage(true);
        } else {
          fetchValidateSelectedSearch();
        }
      })
      .catch(() => {
        fetchValidateSelectedSearch();
      });
  };

  const pushReserve = flightValidate => {
    localStorage.removeItem(storageKey);

    history.push({
      pathname: FLIGHTS_RESERVE,
      state: {
        flightValidate,
        infoFlightsSearch,
        isBuy: isBuy,
        flightsInUSD,
        storageKey,
      },
    });
  };

  const fetchValidateSelectedSearch = () => {
    validateSelectedSearch(body)
      .then(res => {
        setOpenModalBaggage(false);
        const totalDifference = res.difference.total_difference;

        if (
          (flightsInUSD.isInUSD && Math.abs(totalDifference) < 5) ||
          (flightsInUSD.isInARS && Math.abs(totalDifference) < 5000)
        ) {
          pushReserve(res);
        } else {
          setDifference(res);
          setOpenModalMessage(true);
        }
        setIsScroll(false);
      })
      .catch(err => {
        console.error('error', err);
        setOpenModalBaggage(false);
        setNotDisponible(true);
        setOpenModalMessage(true);
        setIsScroll(false);
      });
  };

  const selectedOption = flightValidate => {
    pushReserve(flightValidate);
  };

  return {
    differenceBaggage,
    openModalBaggage,
    openModalMessage,
    difference,
    notDisponible,
    isBuy,
    isHandBaggage: activeRadio
      ? activeRadio[0]?.flight_baggage.hand_baggage
      : false,
    selectedFlightBaggage: activeRadio?.[0]?.flight_baggage,
    selectedOption,
    validateBaggage,
    setOpenModalMessage,
    setOpenModalBaggage,
    setDifferenceBaggage,
    setNotDisponible,
  };
};

export default useActionCluster;
